import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';
import userPreferences from 'static/script/app/data/user-preferences';

function ResultLayout() {
    this.defaultAttrs({
        layouts: [],
        layoutButtonSelector: '[data-search-result-toggle-layout]',
        layoutVersion: 'search-result-toggle-layout-version'
    });

    this._changed = function(e, data) {
        let i,
            length = this.attr.layouts.length,
            targetLayout = data.targetLayout,
            layout;
        for (i = 0; i < length; i++) {
            layout = this.attr.layouts[i];
            if (layout !== targetLayout) {
                this.$node.removeClass(layout);
            }
        }
        this.$node.addClass(targetLayout);

        let userPreferencesKey = this.$node.data(this.attr.layoutVersion);

        userPreferences.set(userPreferencesKey, targetLayout);
        this.trigger(document, 'ui:search:layout', {
            label: 'Change to ' + targetLayout
        });

        if (this.$node.data('result-layout-test-enabled') === 'True') {
            this._trackChange(targetLayout);
        }
    };

    this._trackChange = function(targetLayout) {
        let bucket = this.$node.data('result-layout-test-bucket');

        this.trigger(document, 'analytics:track-event', {
            category: 'List view split test',
            action: bucket,
            label: targetLayout
        });
    };

    this._setDefaultLayouts = function() {
        let layouts = [];
        this.select('layoutButtonSelector').each(function() {
            layouts.push($(this).attr('data-search-result-toggle-layout'));
        });
        this.attr.layouts = layouts;
    };

    this.after('initialize', function() {
        this._setDefaultLayouts();

        this.on(document, 'ui:search:on-layout-change', this._changed);
    });
}

export default defineComponent.component(ResultLayout);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/search-result/result-layout.js